import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";

interface UnitTableFeaturedFilterProps {
    selectedFeatured: boolean;
    onSelectionChange: (showFeaturedOnly: boolean) => void;
}

export const UnitTableFeaturedFilter = ({
    selectedFeatured,
    onSelectionChange,
}: UnitTableFeaturedFilterProps) => {
    const { featuredUnits } = useDisplayOptionContext();

    // Only offer the filter when featured groups are configured.
    if (!featuredUnits?.length) return null;

    return (
        <div>
            <p className="tw:font-bold">By Featured</p>
            <div className="tw:items-start tw:flex-row tw:flex tw:space-x-3 tw:space-y-0 tw:py-1">
                <Checkbox
                    id="featured-only"
                    onCheckedChange={(checked) =>
                        onSelectionChange(checked === true)
                    }
                    checked={selectedFeatured}
                />
                <Label
                    htmlFor="featured-only"
                    className="tw:text-sm tw:font-normal tw:ml-2"
                >
                    Featured units
                </Label>
            </div>
        </div>
    );
};
